export const calendar = {
  title: 'Mon Agenda',
  subtitle: 'Gérez vos disponibilités et synchronisez vos calendriers',
  
  calendar: {
    today: 'Aujourd\'hui',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    selectDates: 'Sélectionner des dates',
    blockDates: 'Bloquer dates',
    unblockDates: 'Débloquer ces dates',
    addNote: 'Ajouter une note',
    selectEvent: 'Sélectionnez un événement',
    nMonths: 'mois',
    oneMonth: '1 mois',
    months: {
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre'
    },
    days: {
      monday: 'Lun',
      tuesday: 'Mar',
      wednesday: 'Mer',
      thursday: 'Jeu',
      friday: 'Ven',
      saturday: 'Sam',
      sunday: 'Dim'
    }
  },
  
  sync: {
    title: 'Synchronisation iCal',
    description: 'Connectez votre calendrier Airbnb ou PMS pour synchroniser automatiquement vos disponibilités',
    addConnection: 'Ajouter une connexion',
    noConnections: 'Aucune connexion',
    icalUrl: 'URL iCal',
    icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...',
    platform: 'Plateforme',
    platformPlaceholder: 'Ex: Airbnb, Booking.com, PMS...',
    syncNow: 'Synchroniser maintenant',
    lastSync: 'Dernière synchro',
    eventsImported: 'événements importés',
    status: {
      synced: 'Synchronisé',
      pending: 'En attente',
      error: 'Erreur',
      syncing: 'Synchronisation...'
    },
    remove: 'Supprimer',
    edit: 'Modifier'
  },
  
  exchanges: {
    title: 'Échanges à venir',
    noExchanges: 'Aucun échange prévu',
    viewProfile: 'Voir le profil',
    sendMessage: 'Envoyer un message',
    confirm: 'Confirmer',
    decline: 'Refuser',
    cancel: 'Annuler',
    guests: 'voyageurs',
    status: {
      confirmed: 'Confirmé',
      pending: 'En attente',
      proposal: 'Proposition',
      blocked: 'Bloqué'
    }
  },
  
  legend: {
    title: 'Légende',
    available: 'Disponible',
    confirmed: 'Échange confirmé',
    pending: 'Demande en attente',
    proposal: 'Proposition',
    blocked: 'Dates bloquées'
  },
  
  blockModal: {
    title: 'Bloquer des dates',
    reason: 'Raison (optionnel)',
    reasonPlaceholder: 'Ex: Travaux, vacances personnelles...',
    from: 'Du',
    to: 'Au',
    block: 'Bloquer',
    cancel: 'Annuler'
  },
  
  notifications: {
    datesBlocked: 'Dates bloquées avec succès',
    datesUnblocked: 'Dates débloquées avec succès',
    syncSuccess: 'Synchronisation réussie',
    syncError: 'Erreur de synchronisation',
    connectionAdded: 'Connexion ajoutée avec succès',
    connectionRemoved: 'Connexion supprimée',
    exchangeConfirmed: 'Échange confirmé',
    exchangeDeclined: 'Échange refusé'
  },

  details: 'Détails',
  upcomingExchanges: 'Échanges à venir',
  noExchangesPlanned: 'Aucun échange prévu',
  daysSelected: 'jours sélectionnés',
  daySelected: 'jour sélectionné',
  from: 'Du',
  to: 'au',
  reasonOptional: 'Raison (optionnel)',
  reasonPlaceholder: 'Ex: Vacances personnelles...',
  block: 'Bloquer',
  cancel: 'Annuler',
  namePlaceholder: 'Nom (ex: Airbnb)',
  filters: 'Filtres',
  actions: 'Actions',
  connections: 'Connexions'
};
